// Web-safe mock for react-native-fs
// Provides basic file system operations for web compatibility

import enTranslation from '../../src/asset/linked/translation/en.json';

export const MainBundlePath = '/mock/bundle';

const mockTranslationFiles = [{name: 'en.json'}];

const mockTranslations = {
  'custom/en.json': JSON.stringify(enTranslation),
};

export const readDirAssets = path => {
  return Promise.resolve(mockTranslationFiles);
};

export const readFileAssets = filePath => {
  const content = mockTranslations[filePath] || JSON.stringify({});
  return Promise.resolve(content);
};

export const readDir = path => {
  return Promise.resolve(mockTranslationFiles);
};

export const readFile = filePath => {
  const languageCode = filePath.split('/').pop().replace('.json', '');
  const mockPath = `custom/${languageCode}.json`;
  const content = mockTranslations[mockPath] || JSON.stringify({});
  return Promise.resolve(content);
};

const RNFS = {
  MainBundlePath,
  readDirAssets,
  readFileAssets,
  readDir,
  readFile,
};

export default RNFS;
